import * as React from 'react';
import SuperCritical from 'lib/supercritical';
import { tzmoment } from 'lib/tzmoment';
import TZDate from 'lib/TZDate';
import { InPortVessels } from './inport';
import { GoToPortCall } from './model';
import { LoadingIcon } from './loadingicon';

export const InPortView = SuperCritical(({ model, goToPortCall } : { model : InPortVessels, goToPortCall : GoToPortCall }) =>
    <div className="homepage-inport">
        <LoadingIcon loading = {model.Loading} />
        <ul>
            {model.InPortVessels().map(p =>
                <li>
                    <label className="port-name">{p.PortName}</label>
                    <ul>
                        {p.InPortVessels!.map(v =>
                            <li className="vessel" onClick = {e => goToPortCall(v)}>
                                <label className="berth">{v.BerthName}</label>
                                <label className="vessel">{v.VesselName}</label>
                                <label className="description">departs {tzmoment(new TZDate(v.DepartureDate)).calendar(tzmoment(model.Date))}</label>
                            </li>
                        )}
                        {p.InPortVessels!.length === 0 
                            ? <li>
                                <label className="no-inport-message">No vessels at this port.</label>
                            </li> 
                            : null}
                    </ul>
                </li>
            )}
        </ul>
    </div>);


// WEBPACK FOOTER //
// ./apps/portcall/homepage/inportview.tsx